import { useEffect, useState } from "react";
import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
const abs = (u) => (u ? `${BASE}${u}` : null);

// Public gallery content uploaded by the owner from the private inbox.
export const useGallery = () => {
  const [data, setData] = useState({ before_after: [], brand: [], loaded: false });
  useEffect(() => {
    axios
      .get(`${BASE}/api/gallery`)
      .then(({ data }) =>
        setData({
          loaded: true,
          before_after: data.before_after.map((p) => ({ ...p, before: abs(p.before_url), after: abs(p.after_url), sessions: p.caption })),
          brand: data.brand.map((b) => ({ ...b, url: abs(b.url) })),
        })
      )
      .catch(() => setData((d) => ({ ...d, loaded: true })));
  }, []);
  return data;
};
